import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Zap } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/', label: 'Ana Sayfa', testId: 'nav-link-home' },
  { path: '/sponsorlar', label: 'Sponsorlar', testId: 'nav-link-sponsorlar' },
  { path: '/sans-oyunlari', label: 'Sans Oyunlari', testId: 'nav-link-sans-oyunlari' },
  { path: '/cekilisler', label: 'Cekilisler', testId: 'nav-link-cekilisler' },
  { path: '/store', label: 'Store', testId: 'nav-link-store' },
  { path: '/iletisim', label: 'Iletisim', testId: 'nav-link-iletisim' },
];

export const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <nav className="navbar" data-testid="primary-navigation-menu">
        <div className="navbar-inner">
          <Link to="/" className="navbar-brand">
            <Zap size={22} style={{ color: 'hsl(200, 96%, 60%)' }} />
            <span>Bet<span className="brand-accent">Max</span></span>
          </Link>

          <div className="navbar-links">
            {NAV_ITEMS.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`navbar-link ${location.pathname === item.path ? 'active' : ''}`}
                data-testid={item.testId}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <button
            className="mobile-menu-btn"
            onClick={() => setMobileOpen(true)}
            data-testid="mobile-nav-open-button"
            aria-label="Menu"
          >
            <Menu size={20} />
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileOpen(false)}>
          <div
            className="mobile-menu-panel"
            onClick={e => e.stopPropagation()}
            data-testid="mobile-nav-sheet"
          >
            <button
              className="mobile-menu-close"
              onClick={() => setMobileOpen(false)}
              aria-label="Close menu"
            >
              <X size={18} />
            </button>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.5rem', paddingLeft: '1rem' }}>
              <Zap size={20} style={{ color: 'hsl(200, 96%, 60%)' }} />
              <span style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 700, fontSize: '1.2rem', color: 'hsl(210, 20%, 96%)' }}>
                Bet<span style={{ color: 'hsl(200, 96%, 60%)' }}>Max</span>
              </span>
            </div>
            {NAV_ITEMS.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => setMobileOpen(false)}
                data-testid={`mobile-${item.testId}`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
